// constants/selectOptions.js
export const orderStatusOptions = [
    { value: "PENDING", label: "대기중" },
    { value: "SELECTED", label: "배정단계" },
    { value: "MATCHED", label: "배정확정" },
    { value: "ON_PROCESS", label: "진행중" },
    { value: "FINISH", label: "완료" },
    { value: "CANCEL", label: "취소" },
];

export const carStatusOptions = [
    { value: "", label: "전체", tagColor: "tag-nav" },
    { value: "PENDING", label: "대기중", tagColor: "tag-nav" },
    { value: "CONTRACT_ING", label: "계약중", tagColor: "tag-green" },
    { value: "DELIVERY_ING", label: "배차중", tagColor: "tag-blue" },
    { value: "FIX", label: "수리중", tagColor: "tag-complete" },
    { value: "NO_DRIVE", label: "미운행", tagColor: "tag-gray_600" },
    { value: "SELL", label: "매각", tagColor: "tag-sub" },
];

export const washStatusOptions = [
    { value: "ALL_NEED", label: "전체세차필요", txtColor: "text-main" },
    { value: "IN_NEED", label: "내부세차필요", txtColor: "text-gray_600" },
    { value: "OUT_NEED", label: "외부세차필요", txtColor: "text-gray_600" },
    { value: "FINISH", label: "세차완료", txtColor: "text-complete" },
];

// 오더 유형
export const orderTypeOptions = [
    { value: "INSURANCE_RENT", label: "보험대차", tagColor: "tag-nav" },
    //{ value: "WARRANTY_RENT", label: "보증대차", tagColor: "tag-green" },
    //{ value: "LONG_RENT", label: "장기렌트", tagColor: "tag-blue" },
    // { value: "MONTH_RENT", label: "월렌트", tagColor: "tag-complete" },
    // { value: "SHORT_RENT", label: "단기렌트", tagColor: "tag-gray_600" },
    // { value: "DELIVERY", label: "탁송", tagColor: "tag-sub" },
];

export const policyNameOptions = [
    { value: "자동차 대여표준약관", label: "자동차 대여표준약관" },
    { value: "개인정보 수집, 이용 및 제3자 제공 동의", label: "개인정보 수집, 이용 및 제3자 제공 동의" },
    { value: "고유식별정보 처리 동의", label: "고유식별정보 처리 동의" },
    { value: "운전자격 검증 확인", label: "운전자격 검증 확인" },
    { value: "기타 별도 특약", label: "기타 별도 특약" },
];

export const originTypeOptions = [
    { value: "DOMESTIC", label: "국산" },
    { value: "IMPORT", label: "수입" },
];

export const vehicleTypeOptions = [
    { value: "경차", label: "경차" },
    { value: "소형차", label: "소형차" },
    { value: "준중형차", label: "준중형차" },
    { value: "중형차", label: "중형차" },
    { value: "대형차", label: "대형차" },
    { value: "스포츠카", label: "스포츠카" },
    { value: "RV", label: "RV" },
    { value: "SUV", label: "SUV" },
    { value: "승합차", label: "승합차" },
    { value: "화물차", label: "화물차" },
    { value: "버스", label: "버스" },
    { value: "특장차", label: "특장차" },
    { value: "기타", label: "기타" },
];

export const transmissionTypeOptions = [
    { value: "MANUAL", label: "수동" },
    { value: "AUTO", label: "자동" },
];

export const originOptions = [
    { value: "1", label: "국산" },
    { value: "2", label: "수입" },
];

export const transmissionOptions = [
    { value: "CVT", label: "CVT" },
    { value: "MANUAL", label: "수동" },
    { value: "AUTO", label: "오토" },
];

export const vehicleStatusOptions = [
    { value: "PENDING", label: "대기중" },
    { value: "FIX", label: "수리중" },
    { value: "NO_DRIVE", label: "미운행" },
    { value: "SELL", label: "매각" },
];

export const displacementOptions = [
    { value: 0, label: "전기/수소차" },
    { value: 1000, label: "1,000cc 이하" },
    { value: 1600, label: "1,600cc 이하" },
    { value: 2000, label: "2,000cc 이하" },
    { value: 2500, label: "2,500cc 이하" },
    { value: 3000, label: "3,000cc 이하" },
    { value: 3500, label: "3,500cc 이하" },
    { value: 9999, label: "3,500cc 초과" },
];

export const insuranceAgeOptions = [
    { value: 21, label: "만 21세 이상" },
    { value: 23, label: "만 23세 이상" },
    { value: 26, label: "만 26세 이상" },
    { value: 30, label: "만 30세 이상" },
    { value: 35, label: "만 35세 이상" },
];

export const fuelRateOptions = [
    { value: 0, label: "0%" },
    { value: 5, label: "5%" },
    { value: 10, label: "10%" },
    { value: 15, label: "15%" },
    { value: 20, label: "20%" },
    { value: 25, label: "25%" },
    { value: 30, label: "30%" },
    { value: 35, label: "35%" },
    { value: 40, label: "40%" },
    { value: 45, label: "45%" },
    { value: 50, label: "50%" },
    { value: 55, label: "55%" },
    { value: 60, label: "60%" },
    { value: 65, label: "65%" },
    { value: 70, label: "70%" },
    { value: 75, label: "75%" },
    { value: 80, label: "80%" },
    { value: 85, label: "85%" },
    { value: 90, label: "90%" },
    { value: 95, label: "95%" },
    { value: 100, label: "100%" },
];

export const contractMonthOptions = [
    { value: 6, label: "6개월" },
    { value: 12, label: "12개월" },
    { value: 24, label: "24개월" },
    { value: 36, label: "36개월" },
    { value: 48, label: "48개월" },
    { value: 60, label: "60개월" },
    { value: 72, label: "72개월" },
];

// 보험 종류
export const insuranceTypeOptions = [
    { value: "DAEIN_PAY_1", label: "대인배상1" },
    { value: "DAEIN_PAY_2", label: "대인배상2" },
    { value: "DAEMUL_PAY", label: "대물배상" },
    { value: "NO_INS_INJURY", label: "무보험차상해" },
    { value: "JASON_DEAD", label: "자손 사망" },
    { value: "JASON_INJURY", label: "자손 부상" },
    { value: "JASON_BLOCK", label: "자손 장해" },
    { value: "SELF_CAR_DAMAGE", label: "자기차량손해" },
];

// 긴급출동
export const emergencyServiceOptions = [
    { value: 3, label: "연 3회" },
    { value: 5, label: "연 5회" },
    { value: 6, label: "연 6회" },
];

// 대인 배상 I
export const daeinPay1Options = [
    { value: "LAW_MAX", label: "자배법 규정 한도" },
    { value: "UN_LIMIT", label: "무한" },
];

// 대인 배상 II
export const daeinPay2Options = [
    { value: -1, label: "1인당 무한" },
    { value: 50000000, label: "1인당 5천만원" },
    { value: 100000000, label: "1인당 1억원" },
    { value: 200000000, label: "1인당 2억원" },
    { value: 300000000, label: "1인당 3억원" },
];

// 대물 배상
export const daemulPayOptions = [
    { value: 10000000, label: "1천만원" },
    { value: 20000000, label: "2천만원" },
    { value: 30000000, label: "3천만원" },
    { value: 40000000, label: "4천만원" },
    { value: 70000000, label: "7천만원" },
    { value: 100000000, label: "1억원" },
    { value: 200000000, label: "2억원" },
    { value: 300000000, label: "3억원" },
];

// 자동차상해 (사망, 부상, 장해) 공통
export const jasonOptions = [
    { value: 10000000, label: "1천만원" },
    { value: 15000000, label: "1천 5백만원" },
    { value: 30000000, label: "3천만원" },
    { value: 50000000, label: "5천만원" },
    { value: 100000000, label: "1억원" },
];

// 자기차량손해: 첫 번째 Select
export const selfCarDamageTypeOptions = [
    { value: "PRICE", label: "금액" },
    { value: "RATE", label: "비율(차량가액기준)" },
];

// 자기차량손해: 금액
export const selfCarDamageAmountOptions = [
    { value: 10000000, label: "1천만원" },
    { value: 30000000, label: "3천만원" },
    { value: 50000000, label: "5천만원" },
    { value: 100000000, label: "1억원" },
    { value: 200000000, label: "2억원" },
    { value: 300000000, label: "3억원" },
];

// 자기차량손해: 비율
export const selfCarDamageRateOptions = [
    { value: "RATE_10_50", label: "10% 최대 50만원" },
    { value: "RATE_10_100", label: "10% 최대 100만원" },
    { value: "RATE_10_200", label: "10% 최대 200만원" },
    { value: "RATE_20_50", label: "20% 최대 50만원" },
    { value: "RATE_20_100", label: "20% 최대 100만원" },
    { value: "RATE_20_200", label: "20% 최대 200만원" },
    { value: "RATE_30_50", label: "20% 최대 50만원" },
    { value: "RATE_30_100", label: "20% 최대 100만원" },
    { value: "RATE_30_200", label: "20% 최대 200만원" },
];

// 무보험차상해
export const noInsInjuryOptions = [
    { value: 10000000, label: "1천만원" },
    { value: 30000000, label: "3천만원" },
    { value: 50000000, label: "5천만원" },
    { value: 100000000, label: "1억원" },
    { value: 200000000, label: "2억원" },
];

// 캐피탈 정보
export const capitalCorpOptions = [
    { value: "현대캐피탈", label: "현대캐피탈" },
    { value: "기아캐피탈", label: "기아캐피탈" },
    { value: "KB캐피탈", label: "KB캐피탈" },
];

export const corpTypeOptions = [
    { value: "CORP", label: "법인" },
    { value: "PERSONAL", label: "개인" },
];

// 오더 상태 유형
//PENDING, SELECTED, MATCHED, ON_PROCESS, FINISH
// export const orderStatusOption = [
//     { value: "PENDING", label: "PENDING" },
//     { value: "SELECTED", label: "SELECTED" },
//     { value: "MATCHED", label: "MATCHED" },
//     { value: "ON_PROCESS", label: "ON_PROCESS" },
//     { value: "FINISH", label: "FINISH" },
// ];

//오더 서브상태 유형
//PENDING, SELECTED, CUSTOMER_CHECK, MATCHED, CONTRACT_ING, CONTRACT_FINISH, DELIVERY_ING, DELIVERY_FINISH, FINISH
export const orderSubStatusOption = [
    { value: "PENDING", label: "매칭중", txtColor: "text-complete" },
    { value: "SELECTED", label: "매칭완료", txtColor: "text-main" },
    { value: "CUSTOMER_CHECK", label: "고객 확인중", txtColor: "text-main" },
    { value: "MATCHED", label: "매칭완료", txtColor: "text-main" },
    { value: "CONTRACT_ING", label: "계약서 작성중", txtColor: "text-gray_600" },
    { value: "CONTRACT_FINISH", label: "계약서 작성완료", txtColor: "text-gray_600" },
    { value: "DELIVERY_ING", label: "배송중", txtColor: "text-gray_600" },
    { value: "DELIVERY_FINISH", label: "배차완료", txtColor: "text-main" },
    { value: "RETURN_FINISH", label: "반납완료", txtColor: "text-error" },
    { value: "CHARGE_FINISH", label: "청구완료", txtColor: "text-error" },
    { value: "FINISH", label: "반납완료", txtColor: "text-error" },
    { value: "REQUEST_CANCEL", label: "요청취소", txtColor: "text-error" },
    { value: "ORDER_CANCEL", label: "배차취소", txtColor: "text-error" },
];

// 오더 방법
export const orderMethodOptions = [
    { value: "ALL", label: "전체" },
    { value: "SELECT", label: "지정" },
];

export const expectFaultOptions = [
    { value: "0", label: "무과실", methodAll: "10%", methodSelect: "15%" },
    { value: "10", label: "10%", methodAll: "8%", methodSelect: "12%" },
    { value: "20", label: "20%", methodAll: "5%", methodSelect: "8%" },
    { value: "30", label: "30%", methodAll: "0%", methodSelect: "0%" },
    { value: "-1", label: "모름", methodAll: "추후산정", methodSelect: "추후산정" },
];

// 면허 구분
export const driverTypeOptions = [
    { value: "CLASS_1_BIG", label: "1종 대형" },
    { value: "CLASS_1_NORMAL", label: "1종 보통" },
    { value: "CLASS_2_NORMAL", label: "2종 보통" },
];

// 운전자 구분
export const driverLicenseTypeOptions = [
    { value: "MAIN", label: "제 1 운전자" },
    { value: "ADDITIONAL", label: "제 2 운전자" },
];

export const localCodeOptions = [
    { value: 11, label: "서울(11)" },
    { value: 12, label: "부산(12)" },
    { value: 13, label: "경기(13)" },
    { value: 13, label: "경기남부(13)" },
    { value: 14, label: "강원(14)" },
    { value: 15, label: "충북(15)" },
    { value: 16, label: "충남(16)" },
    { value: 17, label: "전북(17)" },
    { value: 18, label: "전남(18)" },
    { value: 19, label: "경북(19)" },
    { value: 20, label: "경남(20)" },
    { value: 21, label: "제주(21)" },
    { value: 22, label: "대구(22)" },
    { value: 23, label: "인천(23)" },
    { value: 24, label: "광주(24)" },
    { value: 25, label: "대전(25)" },
    { value: 26, label: "울산(26)" },
    { value: 28, label: "경기북부(28)" },
];

export const mobileTypeOptions = [
    { value: "KT", label: "KT" },
    { value: "SKT", label: "SKT" },
    { value: "LG", label: "LG U+" },
    { value: "KT_SAVE", label: "KT 알뜰폰" },
    { value: "SKT_SAVE", label: "SKT 알뜰폰" },
    { value: "LG_SAVE", label: "LG U+ 알뜰폰" },
];

export const branchTypeOptions = [
    { value: "HEAD", label: "본사" },
    { value: "BRANCH", label: "지점" },
    { value: "RESERVATION", label: "예약소" },
];

export const chargeMethodOptions = [
    { value: "INSURANCE_BASE", label: "보험사기준" },
    { value: "RENT_PRICE", label: "렌트사 기준" },
    { value: "INPERSON", label: "직접입력" },
];

export const memberStatusOptions = [
    { value: "PENDING", label: "가입승인대기", tagColor: "tag-gray_600" },
    { value: "ACTIVE", label: "정상", tagColor: "tag-complete" },
    { value: "LEAVED", label: "탈퇴", tagColor: "tag-error" },
];

export const chargeRateOptions = [
    { value: 0, label: "0%" },
    { value: 5, label: "5%" },
    { value: 10, label: "10%" },
    { value: 15, label: "15%" },
    { value: 20, label: "20%" },
    { value: 25, label: "25%" },
    { value: 30, label: "30%" },
    { value: 35, label: "35%" },
    { value: 40, label: "40%" },
    { value: 45, label: "45%" },
    { value: 50, label: "50%" },
    { value: 55, label: "55%" },
    { value: 60, label: "60%" },
    { value: 65, label: "65%" },
    { value: 70, label: "70%" },
    { value: 75, label: "75%" },
    { value: 80, label: "80%" },
    { value: 85, label: "85%" },
    { value: 90, label: "90%" },
    { value: 95, label: "95%" },
    { value: 100, label: "100%" },
];

export const contractStatusOptions = [
    // { value: "", label: "전체" },
    { value: "PENDING", label: "작성완료", txtColor: "text-complete" },
    { value: "SEND_FINISH", label: "전자계약 발송완료", txtColor: "text-main" },
    { value: "SIGN_FINISH", label: "계약싸인완료", txtColor: "text-main" },
    { value: "RETURN_FINISH", label: "반납완료", txtColor: "text-error" },
    { value: "FINISH", label: "계약완료", txtColor: "text-complete" },
    { value: "CHARGE_FINISH", label: "청구완료", txtColor: "text-complete" },
    { value: "PRE_CHARGE_FINISH", label: "선청구", txtColor: "text-main" },
];


export const mileageChargeTypeOptions = [
    // { value: "", label: "전체" },
    { value: "PLUS", label: "충전", txtColor: "text-complete" },
    { value: "MINUS", label: "환전", txtColor: "text-main" },
];


export const mileageUsedTypeOptions = [
    // { value: "", label: "전체" },
    { value: "PLUS", label: "적립", txtColor: "text-complete" },
    { value: "MINUS", label: "사용", txtColor: "text-main" },
];

export const chargeStatusOptions = [
    { value: "PENDING", label: "대기", txtColor: "text-complete" },
    { value: "REQUEST", label: "청구요청", txtColor: "text-main" },
    { value: "FINISH", label: "완료", txtColor: "text-complete" },
    { value: "CANCEL", label: "취소", txtColor: "text-error" },
];

export const rolesOptions = [
    { value: "MASTER", label: "마스터" },
    { value: "ADMIN", label: "관리자" },
    { value: "RENT_CORP", label: "렌트카 업체" },
    { value: "CUSTOMER", label: "고객" },
    { value: "NORMAL_PARTNER", label: "오더 일반 회원" },
    { value: "MECHANIC_PARTNER", label: "공업사 임직원" },
    { value: "INSURANCE_EMP", label: "보험사 임직원" },
    { value: "INSURANCE_SERVICE", label: "보험사현장출동" },
    { value: "SALES_PARTNER", label: "딜러/설계사 영업종사자" },
    { value: "CONTRACT_EMP", label: "정식 계약된 업체 임직원" },
];

export const salesWorkTypeOptions = [
    { value: "CAR_DEALER", label: "자동차 판매사" },
    { value: "MECHANIC", label: "공업사" },
    { value: "RENT_CAR", label: "렌트카" },
    { value: "INSURANCE_SALES", label: "보험 설계사" },
];

export const salesWorkSubTypeOptions = [
    { value: "NEW_CAR_INTERNATIONAL", label: "신차(수입) 영업", type: "CAR_DEALER" },
    { value: "NEW_CAR_DOMESTIC", label: "신차(국산) 영업", type: "CAR_DEALER" },
    { value: "USED_CAR_SALES", label: "중고차 영업", type: "CAR_DEALER" },
    { value: "RENT_CAR_SALES", label: "렌트카 영업", type: "CAR_DEALER" },
    { value: "Q_1", label: "1급 공업사", type: "MECHANIC" },
    { value: "Q_2", label: "2급 공업사", type: "MECHANIC" },
    { value: "Q_3", label: "3급 공업사", type: "MECHANIC" },
    { value: "RENT_CAR_WORKER", label: "렌트카 종사자", type: "RENT_CAR" },
    { value: "INSURANCE_CORP_EMP", label: "보험사 소속", type: "INSURANCE_SALES" },
    { value: "GA_EMP", label: "GA 소속", type: "INSURANCE_SALES" },
];

// 연식 옵션
export const carYearOptions = (() => {
    const currentYear = new Date().getFullYear();
    const options = [];
    for (let year = currentYear; year >= currentYear - 20; year--) {
        options.push({
            value: `${year}-01-01`,
            label: `${year}년`,
        });
    }
    return options;
})();

// 신규 보험 관련 옵션
// 오더콜 계약용 자차면책금 옵션 (미가입 없음)
export const selfCarIndemnityOptionsForOrderCall = [
    { value: 300000, label: "30만원" },
    { value: 500000, label: "50만원" },
    { value: 1000000, label: "100만원" },
];

// 일반 계약용 자차면책금 옵션 (미가입 포함)
export const selfCarIndemnityOptions = [
    { value: null, label: "미가입" },
    { value: 300000, label: "30만원" },
    { value: 500000, label: "50만원" },
    { value: 1000000, label: "100만원" },
];

export const selfCarLimitAmountOptions = [
    { value: 10000000, label: "1천만원" },
    { value: 20000000, label: "2천만원" },
    { value: 30000000, label: "3천만원" },
];

export const selfCarLimitTypeOptions = [
    { value: "PRICE", label: "금액" },
    { value: "PERCENT", label: "비율(차량가액기준)" },
];

export const bodilyInjuryLimitOptions = [
    { value: -1, label: "무한" },
];

export const propertyDamageLimitOptions = [
    { value: 30000000, label: "3천만원" },
    { value: 50000000, label: "5천만원" },
    { value: 100000000, label: "1억원" },
];

export const personalInjuryLimitOptions = [
    { value: 15000000, label: "1천5백만원" },
];

export const deductibleOptions = [
    { value: null, label: "없음" },
    { value: 300000, label: "30만원" },
    { value: 500000, label: "50만원" },
];
